import {
  Item,
  ItemPageQuery,
  ItemResource,
  ItemResourcePage,
  ItemResourcePayload,
  PageOf
} from '@/models'

import {
  generateCreate,
  generateDelete,
  generateRead,
  generateReadPage,
  generateUpdate,
  generateUpdateImage
} from '../crudGenerator'

/**
 * Converts ItemResource to Item.
 *
 * @param resource Reponse data to be converted.
 */
export function parseItemResource (resource: ItemResource): Item {
  return {
    id: resource.id,
    name: resource.name,
    description: resource.description,
    imageId: resource.imageId,
    price: resource.price,
    updatedAt: new Date(resource.updatedAt),
    isAvailable: resource.available // Renaming
  }
}

/**
 * Converts ItemResourcePage to PageOf<Item>.
 *
 * @param resource Reponse data to be converted.
 */
export function parseItemResourcePage (page: ItemResourcePage): PageOf<Item> {
  return {
    elements: page.items.map(parseItemResource),
    total: page.count
  }
}

const url = '/menu'
const entity = 'items'

export default {
  /**
   * Creates a new Item.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param payload Data required to create it.
   */
  createItem: generateCreate<Item, ItemResource, ItemResourcePayload>(url, entity, parseItemResource),

  /**
   * Deletes an Item.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param id Item id to be deleted.
   */
  deleteItem: generateDelete(url, entity),

  /**
   * Gets an Item.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param id Item id to be fetched.
   */
  fetchItem: generateRead(url, entity, parseItemResource),

  /**
   * Gets a page of Items.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param query Query options.
   */
  fetchItemPage: generateReadPage<Item, ItemResourcePage, ItemPageQuery>(url, entity, parseItemResourcePage),

  /**
   * Updates an existing Item.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param id Item id to be updated.
   * @param payload Data required to create it.
   */
  updateItem: generateUpdate<Item, ItemResource, ItemResourcePayload>(url, entity, parseItemResource),

  /**
   * Updates the image for an Item.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param id Item id whose image will be updated.
   * @param formData Form with file to be uploaded.
   */
  updateItemImage: generateUpdateImage(url, entity, parseItemResource)
}
